import 'expose-loader?exposes=$,jQuery,jquery!jquery';
import 'jquery.qrcode';
import 'expose-loader?exposes=GibberishAES!gibberish-aes';
import 'expose-loader?exposes=accounting!accounting';
import 'expose-loader?exposes=moment!moment-timezone';
import * as jsrender from 'jsrender';

jsrender(window.$);

// We need this file only for exposing libraries to the global scope (window).
// This file should be removed after full migration to typescript, importing libraries in place of usage
